import { Phone, CalendarCheck } from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";
import { BUSINESS } from "@/data/siteData";

export default function MobileCallBar() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const go = () => {
    if (pathname === "/book") {
      document.querySelector("#book")?.scrollIntoView({ behavior: "smooth" });
    } else {
      navigate("/book");
    }
  };
  return (
    <div data-testid="mobile-call-bar" className="lg:hidden fixed bottom-0 inset-x-0 z-40 bg-white/95 backdrop-blur border-t border-gray-200 px-3 py-2.5 flex gap-2.5" style={{ paddingBottom: "calc(0.625rem + env(safe-area-inset-bottom))" }}>
      <a data-testid="mobilebar-call" href={BUSINESS.phoneHref} className="btn-accent flex-1 rounded-full py-3 text-sm font-semibold flex items-center justify-center gap-2">
        <Phone size={16} /> Call Now
      </a>
      <button data-testid="mobilebar-book" onClick={go} className="btn-outline flex-1 rounded-full py-3 text-sm font-semibold flex items-center justify-center gap-2">
        <CalendarCheck size={16} /> Book
      </button>
    </div>
  );
}
